<template>
    <Modal
        id="connect-nyala-project-modal"
        ref="connect-nyala-project-modal"
        v-model:open="open"
        title="connect_nyala_project"
        width="2xl"
        @submit="submit"
        @cancel="cancel"
    >
        <div>
            <p>
                {{ $t('detach_nyala_project_modal_info') }}
            </p>
            <br />
            <ul>
                <li v-if="nyalaProject?.asset_id">
                    <strong>{{ $t('asset') }}:</strong>
                    {{ nyalaProject.asset_id }}
                </li>
                <li v-else-if="nyalaProject?.contract_id">
                    <strong>{{ $t('contract') }}:</strong>
                    {{ nyalaProject.contract_id }}
                </li>
                <li>
                    <strong
                        >{{
                            $t('nyala_project_external_tokenized_asset_id')
                        }}:</strong
                    >
                    {{ nyalaProject?.external_tokenized_asset_id }}
                </li>
                <li>
                    <strong
                        >{{ $t('nyala_project_external_project_id') }}:</strong
                    >
                    {{ nyalaProject?.external_project_id }}
                </li>
                <li>
                    <strong>{{ $t('nyala_project_unit_name') }}:</strong>
                    {{ nyalaProject?.unit_name }}
                </li>
                <li>
                    <strong
                        >{{
                            $t('nyala_project_issuer_wallet_seed_id')
                        }}:</strong
                    >
                    {{ nyalaProject?.issuer_wallet_seed_id }}
                </li>
                <li>
                    <strong>{{ $t('nyala_project_issuer_wallet_id') }}:</strong>
                    {{ nyalaProject?.issuer_wallet_id }}
                </li>
                <li>
                    <strong
                        >{{
                            $t('nyala_project_integration_passphrase')
                        }}:</strong
                    >
                    {{ nyalaProject?.integration_passphrase }}
                </li>
            </ul>
        </div>

        <!-- Modal footer -->
        <template #actions>
            <button
                type="submit"
                class="btn-sm bg-danger-500 hover:bg-danger-600 text-white"
            >
                {{ $t('detach') }}
            </button>
        </template>
    </Modal>
</template>
<script setup lang="ts">
import { Modal } from '@src/components'
import { NyalaProject } from '@src/types'
import { useVModels } from '@vueuse/core'

const props = defineProps<{
    open: boolean
    nyalaProject: NyalaProject | null
}>()

const emit = defineEmits(['update:open', 'cancel', 'submit'])

const { open, nyalaProject } = useVModels(props, emit)

function submit() {
    emit('submit')
}

function cancel() {
    emit('cancel')
}
</script>
